import api from '../utils/api';

export const authService = {
  // 注册
  register: (data) => api.post('/auth/register', data),
  
  // 登录
  login: (data) => api.post('/auth/login', data),
  
  // 保存用户信息到本地
  saveUserData: (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },
  
  // 获取当前用户
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
  
  // 退出登录
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  
  // 检查是否登录
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
  
  // 检查是否是管理员
  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'admin';
  }
};

export const productService = {
  // 获取商品列表
  getProducts: (params) => api.get('/products', { params }),
  
  // 获取商品详情
  getProduct: (id) => api.get(`/products/${id}`),
  
  // 获取热门商品
  getHotProducts: () => api.get('/products/hot/list')
};

export const orderService = {
  // 获取我的订单
  getMyOrders: (params) => api.get('/api/orders/my', { params }),
  
  // 根据订单号查询
  queryOrderByNo: (orderNo) => api.get(`/api/orders/query/${orderNo}`),
  
  // 获取订单详情
  getOrder: (id) => api.get(`/api/orders/${id}`)
};

export const paymentService = {
  // 创建支付订单
  createPayment: (data) => api.post('/payment/create', data),
  
  // 查询支付状态
  queryPayment: (orderNo) => api.get(`/payment/query/${orderNo}`)
};

export const adminService = {
  // 获取统计数据
  getStats: () => api.get('/api/admin/stats'),
  
  // 商品管理
  getAdminProducts: (params) => api.get('/api/admin/products', { params }),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  
  // 卡密管理
  getProductCards: (productId, params) => api.get(`/admin/products/${productId}/cards`, { params }),
  batchAddCards: (data) => api.post('/admin/cards/batch', data),
  deleteCard: (id) => api.delete(`/admin/cards/${id}`),
  
  // 订单管理
  getAdminOrders: (params) => api.get('/admin/orders', { params })
};
